// Lightweight error types with zero dependencies.
// Kept separate from api-service.ts so components in the initial bundle
// (e.g. Search.context.tsx) can import AuthError without pulling in
// lib/session.ts → @mango-engineering/makro-oauth-sdk → jose.

export class AuthError extends Error {
  constructor(message = 'Unauthorized') {
    super(message);
    this.name = 'AuthError';
  }
}
